import React, {Component} from 'react';
import logo from './logo.png';
import SectionHost from "./SectionHost";
import './App.css';

var sections = [
    {name:"Home", link:"Home"},
    {name:"Projects", link:"Projects"},
    {name:"Logo", link:"Home", custom:<img src={logo} className="Ag-logo" alt="Ag logo"/>},
    {name:"Research", link:"Research"},
    {name:"Teaching", link: "Teaching"}
    ];

class App extends Component {

    constructor(props) {

        super(props);
        this.state = {
            sectionName: "Home"
        };

    }

    render() {

        var caller = this;

        return (
            <div className="App">
                <div className="Header">
                    <ul className="Nav">
                        {sections.map((section)=>{

                            var clickHandler;

                            if(section.name!=="Logo")
                                clickHandler = ()=>{
                                    caller.switchSection(section.link);
                                }

                            return <li key={section.name} onClick={clickHandler}>{section.custom!==undefined?section.custom:section.name}</li>})

                    }
                    </ul>
                </div>
                <SectionHost section={this.state.sectionName}/>
            </div>
        );
    }

    switchSection(sectionName){

        this.setState({
            sectionName: sectionName
        });

    }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js